export class NoteModel {
  id: number;
  type: string;
  type_id: number;
  title: string;
  note: string;
  source_user_id: number;
  source_user_name: string;
  target_user_id: number;
  target_user_name: string;
  severity: string;
  data: {};
  created_at: string;
  can_edit: boolean;
  can_delete: boolean;
}
